import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import Phases from '../Phases';
import {parseText} from '../../functions/functions';
import * as Strings from '../../constants';

class Scenario extends React.Component{

  constructor(props) {
    super(props);
    this.detailRef = React.createRef();
  }

  filterScenarios = () => {
    let allScenarios = this.props.scenarios;
//      console.log('allScenarios: ', allScenarios);
    let currentScenario = allScenarios.filter(cs => cs.Slug === this.props.scenario);
//      console.log('Scenario: ', currentScenario);
    return currentScenario;
  }

  scrollTo = r => {
    r.current.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  }

  render() {

    const currentScenario = this.filterScenarios();

    return(
      <div className={"scenarioWrapper " + this.props.scenario}>
        {
          currentScenario.map(obj => {
            return(
              <Fragment key={obj.Nr}>


      <Helmet>
        <title>{obj.Title + " · " + Strings.Meta_PageTitle}</title>
      </Helmet>


                <Row className="scenarioHeader">
                  <Col>
                    <div className="scenario">
                      <p className="tag">Scenario {obj.Nr}/4</p>
                      <h1 className="title scenarioCol scenarioBd">{obj.Title}</h1>
                    </div>
                  </Col>
                  <Col>
                    <div className="description">
                      {parseText(obj.Overview, 'p')}
                    </div>

                  </Col>
                </Row>

                <Row className="exploreScenario">
                  <Col>
                    <button
                      className="scenarioBg"
                      onClick={() => this.scrollTo(this.detailRef)
                    }>
                      {Strings.ExploreScenario}
                    </button>
                  </Col>
                </Row>

                {/*

                <Row className="scenarioDetails" ref={this.detailRef}>
                  <Col>
                    <p className="title scenarioCol">{obj.Title}</p>
                  </Col>
                </Row>

                */}

                <div ref={this.detailRef}></div>

                <Phases scenario={this.props.scenario} />
              </Fragment>
            )
          })
        }
      </div>
    )
  }
}
export default Scenario;



// WEBPACK FOOTER //
// ./src/components/Scenario/scenario.js